import { useMemo } from 'react'
import { useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId } from '@/api/generated/company-management-user/company-management-user'
import type {HealthInsuranceEmployeeConfigModel, InsuranceServiceModuleModel} from '@/api/model'
import { unwrap } from '@/utils/unwrap.ts'

export function useHealthInsuranceConfigs(serviceModuleId: number) {
  const query = useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId(serviceModuleId)

  const configsByEmployeeId = useMemo(() => {
    const module = unwrap<InsuranceServiceModuleModel>(query.data)
    const configs = module?.healthInsuranceEmployeeConfigs ?? []
    return new Map(
      configs
        .filter((c): c is HealthInsuranceEmployeeConfigModel & { employeeUserId: string } => c.employeeUserId != null)
        .map((c) => [c.employeeUserId, c])
    )
  }, [query.data])

  return {
    healthConfigsByEmployeeId: configsByEmployeeId,
    isLoading: query.isLoading,
    isError: query.isError,
    refetchHealthConfigs: query.refetch,
  }
}
